import React from 'react'
import BookRideSection from '../components/sections/BookRideSection'
import useMeta from '../hooks/useMeta';
import Meta from '../components/common/Meta';

const TermConditions = () => {
    const meta = useMeta("term-conditions");
    // console.log("terms-conditions Page Meta:", meta);
    return (
        <>
            {/* Meta tags for SEO */}
            {meta && (
                <Meta
                    title={meta.meta_title}
                    description={meta.meta_description}
                    keywords={meta.meta_keywords}
                />
            )}
            <section className="terms_conditions section_pt section_pb">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="privacy_section">
                                <h2 className="title">Terms & Conditions</h2>
                                <p><small>Welcome to Orbicabs By accessing or using our website, mobile apps, or services, you agree
                                    to be bound by the following terms and conditions.</small> </p>
                                <br />
                                <h4>1. Overview</h4>
                                <p>Orbicabs is a transport pre-booking platform that connects customers with third-party
                                    transport service providers (referred to as “transporters”) for city rides, outstation
                                    trips, airport transfers, office commutes, and tour packages.
                                    We do not own or operate vehicles directly. All rides are fulfilled by independently
                                    contracted and verified transporter partners.</p>

                                <h4>2. Booking & Ride Process</h4>
                                <ul>
                                    <li>All rides must be pre-booked through our mobile application or website.</li>
                                    <li>After booking, ride requests are sent to available transporters.</li>
                                    <li>Upon acceptance, the transporter assigns a driver.</li>
                                    <li>Customers will be notified of:</li>
                                    <ul>
                                        <li>Assigned transporter</li>
                                        <li>Driver name & contact</li>
                                        <li>Vehicle number</li>
                                    </ul>
                                    <li>Rides begin only after the driver enters the customer-provided OTP.</li>
                                </ul>

                                <h4>3. Pricing & Payments</h4>
                                <ul>
                                    <li>Fare is calculated based on distance (per km), vehicle type, and ride type (in-city or
                                        outstation).</li>
                                    <li>Our platform charges a commission on top of the base transporter fare.</li>
                                    <li>All applicable taxes (GST, TDS) are included in the final price shown at checkout.</li>
                                    <li>Customers must pay through the app unless otherwise specified.</li>
                                </ul>
                                <h4>4. Refund & Cancellation Policy</h4>
                                <ul>
                                    <li>If no transporter is assigned, the entire amount is refunded automatically.</li>
                                    <li>For regular rides (e.g., airport, city):</li>
                                    <ul>
                                        <li>Full refund if cancelled at least 12 hours before pickup.</li>
                                    </ul>
                                    <li>For tour packages:</li>
                                    <ul>
                                        <li>Refunds are governed by the specific tour policy displayed at the time of booking.
                                        </li>
                                    </ul>
                                    <li>For office commute plans:</li>
                                    <ul>
                                        <li>Rides can be deferred to another working day (limits may apply).</li>
                                        <li>Deferred or unused rides are non-refundable but carried forward within plan
                                            validity.</li>
                                    </ul>
                                </ul>

                                <h4>5. Ride Tracking & Support</h4>
                                <ul>
                                    <li>All rides are GPS-tracked through the driver app.</li>
                                    <li>In case of delays, non-arrival, or issues, our Ride Support Team is available via chat,
                                        call, or in-app support.</li>
                                    <li>A Ride Manager may be assigned to handle complaints, escalations, and refunds, where
                                        applicable.</li>
                                </ul>
                                <h4>6. Responsibilities</h4>
                                <p><strong>a. Customer Responsibilities</strong></p>
                                <ul>
                                    <li>Ensure accurate pickup/drop details are entered.</li>
                                    <li>Share OTP only when ready to begin the ride.</li>
                                    <li>Be available on time to avoid cancellation by the driver.</li>
                                </ul>
                                <p><strong>b. Transporter Responsibilities</strong></p>
                                <ul>
                                    <li>Arrive on time and ensure proper behavior of drivers.</li>
                                    <li>Keep vehicles clean, safe, and roadworthy.</li>
                                    <li>Follow traffic and local laws.</li>
                                </ul>

                                <h4>7. Liability Disclaimer</h4>
                                <ul>
                                    <li>Orbicabs is a facilitator, not the direct provider of transport services.</li>
                                    <li>We are not liable for:</li>
                                    <ul>
                                        <li>Accidents, damages, or delays caused by third-party transporters.</li>
                                        <li>Loss of personal belongings during rides.</li>
                                    </ul>
                                    <li>However, we take all complaints seriously and ensure prompt resolution.</li>
                                </ul>
                                <h4>8. Modifications</h4>
                                <p>We reserve the right to update these Terms & Conditions at any time. Changes will be posted
                                    on this page and reflected with an updated “Effective Date.” Continued use of the platform
                                    indicates your agreement with the updated terms.
                                </p>

                                <h4>9. Contact Us</h4>
                                <p>For any support or queries, please contact:</p>
                                <p><strong>Orbicabs.com.</strong></p>
                                <p>
                                    📞 +91 75 3505 1511<br />
                                    📞 +91 90 4136 4870<br />
                                    📧 support@orbicabs.com<br />
                                    🤝 partner@orbicabs.com
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* book ride section */}
            <BookRideSection />
        </>
    )
}

export default TermConditions